<!-- TEMPLATE -->
<template>
    <div class="dean-form-row">
        <div class="row">
            <div class="small-6 medium-6 large-6 hd-6 columns">
                <p class="input-label">{{ label }}</p> <!-- {{ label | regularCaseString | capitalize  }} -->
            </div>
            <div class="small-6 medium-6 large-6 hd-6 columns">
                <dean-nullable-switch :name="id" :value="value" @input="fieldChanged"></dean-nullable-switch>
            </div>
        </div>
    </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
    // VUE
    import Vue from 'vue';
    import { Component, Prop, Watch } from 'vue-property-decorator';

    // COMPONENTS
    import deanNullableSwitch from './deanNullableSwitch.vue';

    @Component({
        components: {
            deanNullableSwitch,
        },

        // FILTERS
        filters: {
            capitalize(value: any) {
                if (!value) {
                    return '';
                }
                const text = value.toString();
                return text.charAt(0).toUpperCase() + text.slice(1);
            },
            regularCaseString(value: any) {
                if (!value) {
                    return '';
                }

                const text = value.toString();
                return text.replace(/([A-Z])/g, ' $1');
            },
        },
    })

    export default class DeanNullableSwitchFormRow extends Vue {

        // PROPS
        @Prop({default: ''}) protected value!: any;
        @Prop({default: false}) protected disabled!: boolean;
        @Prop({default: false}) protected requiredField!: boolean;
        @Prop({default: ''}) protected label!: string;
        @Prop({default: ''}) protected id!: string;

        public fieldChanged(value: any) {
            this.$emit('input', value);
        }
    }
</script>
<!-- STYLE -->
<style lang="scss" scoped>

    // IMPORT
    @import '~@deanone/dean-components/src/scss/vars';

    .input-label {
        padding-left: 20px;
    }

</style>
